import { render, staticRenderFns } from "./NumberField.vue?vue&type=template&id=630b9abc&"
import script from "./NumberField.vue?vue&type=script&lang=js&"
export * from "./NumberField.vue?vue&type=script&lang=js&"
import style0 from "./NumberField.vue?vue&type=style&index=0&id=630b9abc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports